import React from "react";
import { Content, InfoBox, SectionWrapper, Title } from "./Styled";

export interface Info {
  title: string;
  value: any;
}

interface SectionProps {
  title: string;
  infoList: Info[];
}

const Section = ({ title, infoList }: SectionProps) => {
  return (
    <SectionWrapper>
      <Title>{title}</Title>
      <Content>
        {infoList.map((info: Info) => (
          <InfoBox>
            <div style={{ fontWeight: 700 }}>{info.title}</div>
            {info.value}
          </InfoBox>
        ))}
      </Content>
    </SectionWrapper>
  );
};

export default Section;
